import { render, staticRenderFns } from "./AboutCompany.vue?vue&type=template&id=a93d2086&scoped=true&"
import script from "./AboutCompany.vue?vue&type=script&lang=js&"
export * from "./AboutCompany.vue?vue&type=script&lang=js&"
import style0 from "./AboutCompany.vue?vue&type=style&index=0&id=a93d2086&prod&lang=scss&scoped=true&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a93d2086",
  null
  
)

export default component.exports